import {getLocalisedPropertyValue} from '../../../../../utils/getLocalisedPropertyValue';
import type {WorkforceProfileCompetencyRow} from '../../types/WorkforceProfileTypes';


export const getCompetencyRowName = (row: WorkforceProfileCompetencyRow, language: 'en' | 'de'): string =>
  getLocalisedPropertyValue(
    {
      en: row.nameEn || row.name,
      de: row.nameDe || row.name,
    },
    language
  );
